import { render, staticRenderFns } from "./ConfigAlertAmazonSes.vue?vue&type=template&id=7714f0d6&scoped=true"
import script from "./ConfigAlertAmazonSes.vue?vue&type=script&lang=js"
export * from "./ConfigAlertAmazonSes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7714f0d6",
  null
  
)

export default component.exports